import React from 'react'
import type { Icon } from 'shared/utils'

const CircleMinus = (props: Icon) => {
    const {
        color = 'white',
        background = '#BB1E32',
        size = 40,
        className = 'circle-minus'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <rect width={size} height={size} fill={background} rx={size} />
                <path
                    fill={color}
                    d="M21.332 19h-8.29c-.576 0-1.042.374-1.042.838 0 .463.466.837 1.042.837h14.496c.576 0 1.042-.374 1.042-.837 0-.464-.466-.838-1.042-.838h-6.206z"
                />
            </g>
        </svg>
    )
}

export { CircleMinus }
